@use '../../styling/colors.scss' as *;

.ParameterChip {
  display: grid;
  padding: 2px 6px;
  border: 1px solid $theme-color-divider;
  border-radius: 4px;

  &.white {
    background: $theme-color-background;
  }

  &.transparent {
    background: $color-transparent;
  }

  &.theme-grey {
    background-color: $theme-color-checkbox-disabled-checked-background;
  }
}
